import { render, staticRenderFns } from "./PxColors.vue?vue&type=template&id=61501f96&"
import script from "./PxColors.vue?vue&type=script&lang=js&"
export * from "./PxColors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports